import { useNavigate } from 'react-router-dom'
import styles from './index.module.less'
import { cal } from '@/utils'
import { Image } from 'antd-mobile'
import React from 'react'
import type { ExchangeExtend } from '@/pages/Products1688/types'

interface ProductCellProps {
  item: any
  index: number
  cellWidth: string
  extend: ExchangeExtend
}

const ProductCell: React.FC<ProductCellProps> = (props) => {
  const navigate = useNavigate()
  const { item, index, cellWidth, extend } = props
  const { currency, exchangeRate, decimalPlace } = extend || {}

  const handleGoDetail = (productId: string) => {
    navigate(`/product-1688/detail/${productId}`)
  }

  return (
    <div
      className={styles['product-item']}
      key={index}
      onClick={() => handleGoDetail(item.offerId)}
    >
      <div
        className={styles['img-wrap']}
        data-index={cellWidth}
        style={{ height: cellWidth }}
      >
        <Image
          src={item.imageUrl}
          fit="cover"
          height={cellWidth}
          className={styles['preview-img']}
          lazy={true}
        ></Image>
      </div>
      <div className={styles['text-wrap']}>
        <h3 className={styles['title'] + ' ep-2'}>{item.subjectTrans || ''}</h3>
        <div className={styles['price-wrap']}>
          <span className={styles['symbol']}>{currency}</span>
          <span className={styles['price']}>
            {cal.moneyFormat(
              cal.times(item.priceInfo.price, exchangeRate),
              decimalPlace,
            )}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ProductCell
